import { useContext, useEffect, useState } from "react";
import { getBatch, getSortedCollection, matchQuery } from "sprint-common-web";

import { UserListingContext } from "../../context/UserListingContext";
import { UserItem } from "../UsersListing";
import { UsersListingFilters } from "./useUserListingFilters";

export const useUsersListingData = (filters: UsersListingFilters) => {
    const [items, setItems] = useState<UserItem[]>([]);
    const [totalItems, setTotalItems] = useState<number>(0);

    const { userItems, isLoading } = useContext(UserListingContext);

    useEffect(() => {
        if (userItems.length) {
            loadData({
                name: filters.name,
                page: filters.page,
                pageSize: filters.pageSize,
                sortBy: filters.sortBy,
                sortOrder: filters.sortOrder
            });
        }
    }, [userItems, filters]);

    const loadData = ({ name, page, pageSize, sortBy, sortOrder }: UsersListingFilters): void => {
        const filteredUsers = userItems.filter((user) => matchQuery(user.name, name));

        setTotalItems(filteredUsers.length);

        const sortedCollection = getSortedCollection(filteredUsers, sortBy, sortOrder);

        const slicedUsers = getBatch(sortedCollection, pageSize, page);

        setItems(slicedUsers);
    };

    return {
        items,
        totalItems,
        filterData: loadData,
        isLoading
    };
};
